__turbopack_context__.v({
  "adornment": "eI1UXG_adornment",
  "chevron": "eI1UXG_chevron",
  "clearButton": "eI1UXG_clearButton",
  "hasValue": "eI1UXG_hasValue",
  "itemIconContainer": "eI1UXG_itemIconContainer",
  "label": "eI1UXG_label",
  "menu": "eI1UXG_menu",
  "menuItem": "eI1UXG_menuItem",
  "select": "eI1UXG_select",
  "selectValue": "eI1UXG_selectValue",
  "selectionSize": "eI1UXG_selectionSize",
  "small": "eI1UXG_small",
  "solid": "eI1UXG_solid",
});
